import React from "react";
import { useDispatch } from "react-redux";
import { OrderByRating } from "../../actions";
import "./OrderByRating.css"


export default function OrderRating({setcurrentPage, setOrden}){
    const dispatch = useDispatch();


    function handleOrderRating(event){
        event.preventDefault();
        dispatch(OrderByRating(event.target.value));
        setcurrentPage(1);
        setOrden(`orden ${event.target.value}`)
    }
return(
    <div className="containerRating">
        <select className="selectRating" onChange={event =>{handleOrderRating(event)}}>
            <option value="all">Ordenar por Rating</option>
            <option value="asc">Rating 0 - 5 </option>
            <option value="desc">Rating 5 - 0</option>
        </select>
        <i></i>
    </div>
)
}